module.exports = __webpack_public_path__ + "e34aafbb485a96eaf2a789b2bf3af6fe.gif";